import { useEffect, useState } from 'react'

/**
 * Returns whether the given media query currently matches.
 * SSR-safe: starts as false on server / first paint, then updates after mount.
 */
export function useMediaQuery(query) {
    const [matches, setMatches] = useState(false)

    useEffect(() => {
        if (typeof window === 'undefined' || !window.matchMedia) return
        const mq = window.matchMedia(query)
        const update = () => setMatches(mq.matches)
        update()
        mq.addEventListener?.('change', update) ?? mq.addListener?.(update)
        return () => {
            mq.removeEventListener?.('change', update) ?? mq.removeListener?.(update)
        }
    }, [query])

    return matches
}
